import { useFeatureFlagEnabled } from "posthog-js/react";

export const POSTHOG_URL = "https://ph.api.cerebrum.com";

export const useIsPerformanceLoggingEnabled = () => {
	return useFeatureFlagEnabled("cog-v-id-web-performance-logging");
};

export const useIsSupportButtonEnabled = () => {
	return useFeatureFlagEnabled("v-id-web-support-button");
};

export const useIsIdCaptureEnabled = () => {
	return useFeatureFlagEnabled("v-id-web-id-capture");
};

export const useIsMobileIdCaptureEnabled = () => {
	return useFeatureFlagEnabled("v-id-web-mobile-id-capture");
};

export const useIsSsoLoginEnabled = () => {
	return useFeatureFlagEnabled("cog-sso-login");
};
